<mat-icon>{{ data.icon }}</mat-icon>
<h2 class="atlas-subtitle-1">{{ data.title }}</h2>

@if (data.message) {
  <span [innerHTML]="data.message"></span>
}
